module.exports = __webpack_public_path__ + "img/arrow_right_white.83d13b2e.svg";